import { PayloadAction, SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../@types/GerenciadorPrecos';
import { RootState } from '../../@types/RootState';

export type ContextMenuState = GerenciadorPrecos.RowData | null;

const initialState: ContextMenuState = null;

const slice = createSlice<ContextMenuState, SliceCaseReducers<ContextMenuState>>({
  name: 'ipa/gerenciador/contextMenu',
  initialState,
  reducers: {
    SET_GERENCIADOR_CONTEXT_MENU: (_state, { payload }: PayloadAction<ContextMenuState>) => {
      return payload;
    },
  },
});

const { SET_GERENCIADOR_CONTEXT_MENU } = slice.actions;

const selectorContextMenu = (state: RootState) => {
  return state.gerenciadorPrecosReducer.contextMenu;
};

export const selectorContextMenuItemOffer = (state: RootState) => {
  return state.gerenciadorPrecosReducer.contextMenu?.offer;
};

export { SET_GERENCIADOR_CONTEXT_MENU, initialState, selectorContextMenu };

export default slice.reducer;
